import { graphql } from "@/lib/gql/__generated__";

export const OPTION_PMS_COLOR_LIST_FOR_OPTION_PMS = graphql(/* GraphQL */ `
	query OptionPmsColorListForOptionPms($hotelID: ID!) {
		optionPmsColorList(hotelID: $hotelID) {
			id
			hotelID
			optionColors {
				id
				hotelID
				optionID
				optionName
				color
			}
		}
	}
`);
